<template>
    <div>
        <div v-if="!minimalUi" class="bg-white">
            <div class="flex justify-center border-b border-blue-100 text-grey-500" role="tablist">
                <button
                    v-for="opt in components"
                    :key="opt"
                    class="py-5 mx-3 border-b-4"
                    :class="[
                        opt === active ? 'border-yellow-500 text-blue-500' : 'border-transparent'
                    ]"
                    role="tab"
                    :aria-selected="opt === active ? 'true' : 'false'"
                    @click="changeTab(opt)"
                >
                    {{ opt }}
                </button>
            </div>
        </div>

        <template v-for="opt in components">
            <div v-if="opt === active" :key="opt">
                <div
                    v-if="introText"
                    class="container pt-12 pb-8 mx-auto text-center text-blue-500 wysiwyg"
                    v-html="introText"
                />
                <component
                    :is="opt"
                    :default-extras-category="defaultExtrasCategory"
                    :default-filters-payments="defaultFiltersPayments"
                    :default-filters-services="defaultFiltersServices"
                    :hide-search-bar-ui="hideSearchBarUi"
                    :hide-categories-ui="hideCategoriesUi"
                    :hide-filters-ui="hideFiltersUi"
                    :coordinates="coordinates"
                    :minimal-ui="minimalUi"
                    :view-swappable="viewSwappable"
                    :default-to-list-view="defaultToListView"
                    :use-geo-location="useGeoLocation"
                    :zoom="defaultZoom"
                    :hide-website-in-listings="hideWebsiteInListings"
                    :extras-list-heading="extrasListHeading"
                    :health-partners-providers-only="healthPartnersProvidersOnly"
                />
            </div>
        </template>
    </div>
</template>

<script>
import Hospital from '../hospital-search/App.vue';
import Extras from '../extras-search/App.vue';
import Specialist from '../specialist-search/App.vue';

export default {
    components: {
        Hospital,
        Extras,
        Specialist
    },

    props: {
        defaultExtrasCategory: {
            type: String,
            default: undefined
        },
        defaultFiltersPayments: {
            type: Array,
            default() {
                return [];
            }
        },
        defaultFiltersServices: {
            type: Array,
            default() {
                return [];
            }
        },
        coordinates: {
            type: Object,
            default: undefined
        },
        minimalUi: {
            type: Boolean,
            default: false
        },
        hideSearchBarUi: {
            type: Boolean,
            default: false
        },
        hideFiltersUi: {
            type: Boolean,
            default: false
        },
        hideCategoriesUi: {
            type: Boolean,
            default: false
        },
        viewSwappable: {
            type: Boolean,
            default: false
        },
        defaultToListView: {
            type: Boolean,
            default: false
        },
        useGeoLocation: {
            type: Boolean,
            default: true
        },
        defaultZoom: {
            type: Number,
            default: undefined
        },
        hideWebsiteInListings: {
            type: Boolean,
            default: false
        },
        extrasListHeading: {
            type: String,
            default: ''
        },
        healthPartnersProvidersOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            active: 'Extras',
            components: ['Extras', 'Hospital', 'Specialist']
        };
    },

    computed: {
        introText() {
            return this.$root[this.active.toLowerCase()];
        }
    },

    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const tab = urlParams.get('tab');
        if (['Extras', 'Hospital', 'Specialist'].includes(tab)) {
            this.active = tab;
        }
    },

    methods: {
        changeTab(opt) {
            window.dataLayer.push({
                event: 'GTM',
                event_name: 'switch_provider_search_type',
                content: opt,
                context: null,
                location: null
            });

            this.active = opt;
        }
    }
};
</script>
